import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  FixedAsset,
  FixedAssetCreateDTO,
  FixedAssetRegisterDTO,
  FixedAssetEditDTO,
  DisposeDTO,
} from '../interfaces/fixedAsset/fixedAsset.interface';

export const FixedAssetService = {
  // F10: optional placement filter (location / department / custodian); omitted = any.
  listByInstitution: async (institutionId: string, page = 0, size = 200,
    placement?: { locationId?: string; departmentId?: string; custodianUserId?: string },
  ): Promise<{ content: FixedAsset[]; totalElements: number }> =>
    (await axios.get(`${ENDPOINTS.FIXED_ASSET.LIST_BY_INSTITUTION(institutionId)}?page=${page}&size=${size}`,
      placement ? { params: placement } : undefined)).data,
  getById: async (id: string): Promise<FixedAsset> =>
    (await axios.get(ENDPOINTS.FIXED_ASSET.GET_BY_ID(id))).data,
  create: async (dto: FixedAssetCreateDTO): Promise<FixedAsset> =>
    (await axios.post(ENDPOINTS.FIXED_ASSET.CREATE, dto)).data,
  register: async (dto: FixedAssetRegisterDTO): Promise<FixedAsset> =>
    (await axios.post(ENDPOINTS.FIXED_ASSET.REGISTER, dto)).data,
  update: async (id: string, dto: FixedAssetEditDTO): Promise<FixedAsset> =>
    (await axios.put(ENDPOINTS.FIXED_ASSET.UPDATE(id), dto)).data,
  remove: async (id: string): Promise<void> =>
    (await axios.delete(ENDPOINTS.FIXED_ASSET.DELETE(id))).data,
  dispose: async (id: string, dto: DisposeDTO): Promise<FixedAsset> =>
    (await axios.post(ENDPOINTS.FIXED_ASSET.DISPOSE(id), dto)).data,
  disposeReverse: async (id: string): Promise<FixedAsset> =>
    (await axios.post(ENDPOINTS.FIXED_ASSET.DISPOSE_REVERSE(id))).data,
};
